module.exports = __webpack_public_path__ + "img/28.37a31a27.jpg";